/**
 * SOLID Review
 * S — Strong. One constant, one reason to change.
 * O — N/A — nothing to extend.
 * L — N/A.
 * I — Strong: one export.
 * D — Strong. Depends only on the env reader.
 */
/**
 * The REST base URL, declared ONCE.
 *
 * It was declared three times — authApiService.ts, LegalApiAdapter.ts and ConsentApiAdapter.ts —
 * and the third read `import.meta.env` directly instead of going through `readEnv`, so the three
 * could disagree about what an unset variable means. Nothing detected that, because each file was
 * individually correct.
 */
import { readEnv } from '../../shared/viteEnv';

export const API_BASE: string = readEnv('VITE_API_BASE_URL') ?? '';
